import React, { useState, useEffect, useRef } from 'react';
import { withRouter, matchPath } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  setLink, fetchBook, fetchChapters, fetchPages,
} from '../../actions';
import BookLink from './book-link';

const FlipType = {
  FALSE: 0,
  BACK: 1,
  FORWARD: 2,
};

function Book(props) {
  const [flip, setFlip] = useState(0);
  const mountedRef = useRef(false);
  const hist = props.history;

  const { bookID, chapterID, pageID } = props.match.params;

  // page flipping
  const goBack = () => {
    setFlip(FlipType.BACK);
    setTimeout(
      () => {
        if (mountedRef.current) setFlip(FlipType.FALSE);
      }, 1000,
    );
  };

  const goForward = () => {
    setFlip(FlipType.FORWARD);
    setTimeout(
      () => {
        if (mountedRef.current) setFlip(FlipType.FALSE);
      }, 1000,
    );
  };

  const getParams = (url) => {
    const upToPages = '/books/:bookID/chapters/:chapterID/pages/:pageID';
    const upToChapters = '/books/:bookID/chapters/:chapterID';
    const upToBooks = '/books/:bookID';

    const toReturn = matchPath(url, { path: upToPages }) || matchPath(url, { path: upToChapters }) || matchPath(url, { path: upToBooks });
    if (toReturn) return (toReturn.params);
    return (null);
  };

  // forwards = true, backwards = false
  const shouldGoForwards = (next) => {
    if (!next.bookID || !bookID || next.bookID !== bookID) return true;
    if (!next.chapterID || !chapterID) {
      if (!next.chapterID) return false;
      return true;
    }
    if (next.chapterID !== chapterID) {
      const nextIndex = props.chapters.findIndex((x) => x.id === next.chapterID).bookIndex;
      if (nextIndex && nextIndex < props.currChapter.bookIndex) return false;
      return true;
    }
    if (!next.pageID || !pageID) {
      if (!next.pageID) return false;
      return true;
    }
    if (next.pageID !== pageID) {
      const nextIndex = props.pages.findIndex((x) => x.id === next.pageID).chapterIndex;
      if (nextIndex && nextIndex < props.currPage.chapterIndex) return false;
      return true;
    }
    console.log('in 5!');
    return true;
  };

  // on recieving a new location, determine if before or after, animate aacordingly.
  useEffect(() => {
    if (props.link == null) return;
    const newParams = getParams(props.link);
    if (!newParams) {
      goForward();
      return;
    }
    if (shouldGoForwards(newParams)) goForward();
    else goBack();
  }, [props.link]);

  useEffect(() => {
    if (flip !== FlipType.FALSE && props.link) {
      hist.push(props.link);
      props.setLink(null);
    }
  }, [flip]);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    console.log('useEffect');
    const onContrib = matchPath(props.location.pathname, {
      path: '*/contributors',
    });
    if (!onContrib && !props.match.params.userID && !props.match.params.myID) {
      if (bookID) {
        props.fetchBook(bookID);
        props.fetchChapters(bookID);
        if (chapterID) {
          props.fetchPages(bookID, chapterID);
        }
      }
    }
  }, [props.match.params.bookID, props.match.params.chapterID]);

  // First, check if we are on a page. If we are, and there is a page after this one in list of pages, link to that page.
  // Otherwise, link back to chapter.
  const linkToNextPage = () => {
    if (flip !== 0 || !pageID || props.pages.length < 1 || props.currPage === {}) return <></>;
    if (!props.currPage || !props.currPage.Chapter || !props.currPage.Chapter.Book) return <></>;
    if (matchPath(props.location.pathname, {
      path: '*/edit',
    })) return <></>;
    if (matchPath(props.location.pathname, {
      path: '*/newpage',
    })) return <></>;

    if (props.pages[props.pages.length - 1].chapterIndex > props.currPage.chapterIndex) {
      const thisIndex = props.pages.findIndex((x) => x.id === props.currPage.id);
      if (thisIndex === -1) return <></>;
      const nextIndex = thisIndex + 1;
      const nextId = props.pages[nextIndex].id;
      return (
        <BookLink to={`/books/${props.currPage.Chapter.Book.id}/chapters/${props.currPage.Chapter.id}/pages/${nextId}`}>
          <i className="fas fa-arrow-right next-btn  fade-in" />
        </BookLink>
      );
    }
    return (
      <BookLink
        to={`/books/${props.currPage.Chapter.Book.id}/chapters/${props.currPage.Chapter.id}/pages`}
        className="fake-button next-btn fade-in"
        aria-label="Back to Chapter"
      >
        <i className="fas fa-door-open" />
      </BookLink>
    );
  };

  // If state = flipping, run appropriate animation (via CSS class)
  const flipGroupClass = () => {
    let className = 'flip-group';
    if (flip === FlipType.BACK) {
      className += ' back-flipping';
    }
    if (flip === FlipType.FORWARD) {
      className += ' flipping';
    }
    return className;
  };

  // CSS class for content
  const frontContentClass = () => {
    let className = 'front-page-content';
    if (flip !== FlipType.BACK && flip !== FlipType.FORWARD) {
      className += ' fade-in';
    }
    return className;
  };

  return (
    <div>
      <div className={flipGroupClass()}>
        <div className="front-page">
          {linkToNextPage()}
          <div className={frontContentClass()}>
            {props.children}
          </div>
        </div>
        <div className="back-page" />
      </div>
    </div>

  );
}

const mapStateToProps = (state) => (
  {
    currBook: state.books.current,
    link: state.link,
    chapters: state.chapters.all,
    currChapter: state.chapters.current,
    pages: state.pages.all,
    currPage: state.pages.current,
  }
);

export default withRouter(connect(mapStateToProps, {
  setLink, fetchBook, fetchChapters, fetchPages,
})(Book));
